var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,0a8,8,0,1,0,8,8A8.024,8.024,0,0,0,8,0ZM2.4,8a5.633,5.633,0,0,1,.88-3.04l7.76,7.76A5.633,5.633,0,0,1,8,13.6,5.566,5.566,0,0,1,2.4,8Zm10.32,3.04L4.96,3.28A5.633,5.633,0,0,1,8,2.4,5.566,5.566,0,0,1,13.6,8,5.633,5.633,0,0,1,12.72,11.04Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisable);
export default __webpack_public_path__ + "static/media/Disable.5f11ea4914c503dceffd6535f3a903f5.svg";
export { ForwardRef as ReactComponent };